import { CdkStepperModule } from '@angular/cdk/stepper';
import { NgFor, NgIf } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { Prayer } from '../../../../models/prayer.model';
import { AppState } from '../../../../state/appstate';
import { LoadingDotsComponent } from '../../../components/spinners/loading-dots/loading-dots.component';
// import * as XLSX from 'xlsx';

@Component({
  selector: 'app-load-prayer',
  standalone: true,
  imports: [
    RouterLink,
    NgFor,
    NgIf,
    ReactiveFormsModule,
    LoadingDotsComponent,
    MatStepperModule,
    CdkStepperModule,
  ],
  templateUrl: './load-prayer.component.html',
  styleUrls: ['./load-prayer.component.css'],
})
export class LoadPrayerComponent {
  readContent() {
    throw new Error('Method not implemented.');
  }
  @ViewChild('stepper') private stepper!: MatStepper;

  pageForm: FormGroup;

  file: File | null = null;
  excelData: any[] = [];

  prayers: Prayer[] = [];

  loading: boolean = false;

  constructor(private fb: FormBuilder, private store: Store<AppState>) {
    this.pageForm = this.fb.group({
      prayerText: ['', Validators.required],
      // description: ['', Validators.required],
    });
  }

  pickFile($event: any) {
    this.file = $event.target.files[0];
  }

  readFile() {}

  // readFile() {
  //   if (this.file != null) {
  //     let fileReader = new FileReader();
  //     fileReader.onload = async (e) => {
  //       var workBook = XLSX.read(e.target?.result, { type: 'binary' });
  //       var sheetNames = workBook.SheetNames;
  //       console.log('Sheet Names:', sheetNames);
  //       var sheet = workBook.Sheets[sheetNames[0]];
  //       this.excelData = XLSX.utils.sheet_to_json(sheet);
  //       this.excelData.map((data: any) => {
  //         let prayer: Partial<Prayer> = {
  //           subject: data.subject ?? data.Subject ?? data.SUBJECT,
  //           description:
  //             data.description ?? data.Description ?? data.DESCRIPTION,
  //           category: data.category ?? data.Category ?? data.CATEGORY,
  //           created: data.created ?? data.Created ?? data.CREATED,
  //           // tags: data.tags ?? data.Tags ?? data.TAGS,
  //         };
  //       });
  //       console.log('Excel Data:', JSON.stringify(this.excelData));
  //     };
  //     fileReader.readAsArrayBuffer(this.file);
  //     this.stepper.next();
  //   }
  // }

  bulkUpload() {
    throw new Error('Method not implemented.');
  }
}
